import { AlertContext } from "contexts/AlertContext"
import Modal from "components/Modal/Modal"
import { POST } from "api/request"
import { useContext } from "react"
import * as url from 'api/urls'

interface PublishModalProps {
  onClose: () => void
  mediaId: string
  action: string
  onReload: () => void
}

const PublishModal: React.FC<PublishModalProps> = ({ mediaId, action, onClose, onReload }) => {
  const { showAlert } = useContext(AlertContext)

  const handleSubmit = async () => {
    try {
      const response = await POST(url.publishMedia(mediaId), {
        body: {
          publish: action === 'publish' ? true : false
        }
      })
      if (response.ok) {
        onReload()
        onClose()
        showAlert(action === 'publish' ? 'Opublikowano' : 'Wyłączono z internetu', 'success')
      } else {
        showAlert('Wystąpił błąd', 'error')
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Modal
      icon='share'
      onClose={onClose}
      title='Publikowanie'
      primaryButton={action !== 'publish' ? 'Ukryj' : 'Opublikuj'} primaryButtonAction={() => handleSubmit()}
      secondaryButton={'Anuluj'} secondaryButtonAction={'close'}>
      <div className="center">
        {action === 'publish'
          ? 'Klikając: "opublikuj", zdjęcie będzie mógł zobaczyć kazdy kto zeskanuje kod z nagrobka'
          : 'Klikając: "ukryj", zdjęcie nie będzie juz dostępne publicznie, a jedynie w twoim panelu zarządzania pomnikiem'}
      </div>
    </Modal>
  )
}

export default PublishModal